import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F47500",
      d: "M6.116.676a1 1 0 0 1 1.768 0L9.216 3.2a1 1 0 0 0 .714.518l2.81.487a1 1 0 0 1 .547 1.682L11.3 7.933a1 1 0 0 0-.273.84l.406 2.823a1 1 0 0 1-1.43 1.04l-2.56-1.259a1 1 0 0 0-.883 0l-2.56 1.259a1 1 0 0 1-1.431-1.04l.406-2.824a1 1 0 0 0-.273-.84L.713 5.888a1 1 0 0 1 .546-1.682l2.811-.487a1 1 0 0 0 .714-.518z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "star-1"}) } }